import React from "react";
import QueueAnim from 'rc-queue-anim';
import './index.less'
import { Card, Row, Col, Collapse } from 'antd';
import ScrollOverPack from 'rc-scroll-anim/lib/ScrollOverPack';
import TweenOne from 'rc-tween-one';
import { enquireScreen } from 'enquire-js';
let isMobile;
enquireScreen((b) => {
    isMobile = b;
});

const { Panel } = Collapse;
const { Meta } = Card;

export default class DatalinkContent2 extends React.Component {
    callback(key) {
        console.log(key);
    }

    render() {
        const cardStyle = {
            width: 320,
            padding: 8,
            margin: "0 auto"
        }
        return (
            <ScrollOverPack className='Datalink-content2'>
                <Row>
                    <Col xs={24} sm={24} md={12} lg={12}>
                        <QueueAnim
                            key="QueueAnim"
                            type={['bottom', 'top']}
                            delay={200}
                            className='text-wrapper Datalink-text'
                        >
                            
                            <div className="split-line"></div>
                            <p style={{ fontSize: isMobile ? '22px' : '28px', marginLeft: '8px', color: '#fff' }}>地面天线一体化设计</p>
                            <p><span>· </span>跟踪天线和全定向天线在不同范围内可选。</p>
                            <p><span>· </span>单一接口向地面站同时提供电源和信号传输。</p>
                            <p><span>· </span>全定一体天线可根据飞机实时距离自动切换定向或全向模式。</p>
                            <p><span>· </span>跟踪天线能够自动探测并保持指向无人机的精确方向，推荐<br></br>&nbsp; 用于50公里以上的传输。</p>
                        </QueueAnim>
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={12}>
                        <TweenOne
                            key="image"
                            className="image-wrapper Datalink-content-image2"
                            animation={{ x: 0, opacity: 1, ease: 'easeOutQuad' }}
                            style={{ transform: 'translateX(-100px)', opacity: 0 }}
                        />
                    </Col>
                </Row>
            </ScrollOverPack>
        )

    }
}
